module.exports = __webpack_public_path__ + "static/img/northern.323f9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/northern.png
// module id = dcZI
// module chunks = 0